// extracted by mini-css-extract-plugin
export const root = "blog-post-preview-grid-module--root--1UtTg";
export const headline = "blog-post-preview-grid-module--headline--3nBN3";
export const grid = "blog-post-preview-grid-module--grid--2QwxY";
export const browseMoreNav = "blog-post-preview-grid-module--browseMoreNav--2_oZ9 typography-module--small--2jpCI";